/*!
 * @copyright
 * Copyright(c) 2019 SICK AG
 */
import { Vector3 } from 'three';
import { BasePanNavigator } from './BasePanNavigator';
import { NavUtils } from './NavUtils';
const INTERNAL_SPEED_FACTOR = 0.0015;
const INTERNAL_MOUSE_PAN_FACTOR = 0.25;
const INTERNAL_WHEEL_TOUCH_FACTOR = 3;
/**
 * Navigator for fore and back movement
 */
export class StraightAheadNavigator extends BasePanNavigator {
    constructor(cam, el, speed = 1) {
        super(cam, el, speed);
        this.mousePanFactor = 1;
        this.wheelTouchFactor = 1;
        this.allowPanDuringPinch = false;
        this.updatePivot = false;
        this._onPinch = (event) => {
            if (this._enabled) {
                const { scale, isWheel } = event.detail;
                const movement = scale * this.speed * INTERNAL_SPEED_FACTOR * (isWheel ? this.wheelTouchFactor * INTERNAL_WHEEL_TOUCH_FACTOR : 1);
                this._updatePosition(movement);
            }
        };
        this._isMovementPermitted = () => true;
        const eventListenerOptions = { passive: true }; // edge and ie11 need identical options to match
        // listener for removal
        el.addEventListener('pinch', this._onPinch, eventListenerOptions);
        const { dispose: superDispose } = this;
        this.dispose = (() => {
            superDispose();
            // @ts-ignore
            el.removeEventListener('pinch', this._onPinch, eventListenerOptions);
        });
    }
    setIsMovementAllowed(func) {
        this._isMovementPermitted = func;
    }
    pan(event) {
        const movement = event.detail.movementY * this.speed * INTERNAL_MOUSE_PAN_FACTOR * this.mousePanFactor * INTERNAL_MOUSE_PAN_FACTOR;
        this._updatePosition(movement);
    }
    _updatePosition(movement) {
        const cam = this._cam;
        const trans = new Vector3();
        cam.getWorldDirection(trans);
        trans.multiplyScalar(movement);
        cam.position.add(trans);
        if (this._isMovementPermitted(cam)) {
            if (this.updatePivot) {
                NavUtils.getPivot(cam).add(trans);
            }
        }
        else {
            cam.position.sub(trans);
        }
    }
}
//# sourceMappingURL=StraightAheadNavigator.js.map